<script>  
    import MatchEdges from './matchview/MatchEdges.svelte';
    import Creditcards from './matchview/Creditcards.svelte';
    import Cars from './matchview/Cars.svelte';
    import Matches from './matchview/Matches.svelte';

    // --- Properties
    export let dataKey;   
    let width, height;
</script>


<div class='row card' bind:clientWidth={width} bind:clientHeight={height}>
    <MatchEdges {dataKey} {width} {height} />
    <Cars {dataKey} />
    <Matches {dataKey} />
    <Creditcards {dataKey} />
</div>

<style>
    div {
        flex-grow: 0;
    }
</style>